import { api } from "../lib/api";

// Vision LLM — analyze uploaded selfie (GPT-5.4 Vision via backend)
export async function analyzeSelfie(imageBase64, occasion) {
  const { data } = await api.post("/ai/analyze-selfie", {
    image_base64: imageBase64,
    occasion,
  });
  return data; // { faceShape, hairTexture, skinTone, beardStatus, styleVibe, confidence, notes }
}
